import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { SettingPermissionModel } from "@/model/user/ApplicationPermissionModel";

export function DefineSettingPermissionAbility(settingPermission: SettingPermissionModel, can: any) {
  const { setting } = settingPermission;

  setting && can(AbilityAction.Update, AbilitySubject.Setting);
}
